import { v4 } from 'uuid';
import Cookies from 'js-cookie';

export default {
  name: 'ui',
  
  getReducer: () => {
    const initialData = {
      shouldGetCookie: true,
      shouldSetCookie: false,
      northConfig:{
        height: window.innerHeight
      },
      southConfig:{
        height: 0,
        children: []
      },
      primaryPanelConfig:{
        openedBy: null,
        width: 300,
        children: [],
        options: null
      },
      secondaryPanelConfig:{
        open: false,
        width: 300,
        children: [],
        options: null
      },
      modalConfig:{
        children: [],
        options: null,
        openedBy: null
      },
      basicToolbarConfig:{
        activeTool: null
      },
      theme: null,
      _shouldHandleWindowResize: false,
      _shouldResetMap: false
    }

    return (state = initialData, { type, payload }) => {

      if(type === 'UI_RESET_MAP'){
        return Object.assign({}, state, {
          _shouldResetMap: false
        })
      }

      if(type === 'WINDOW_RESIZE'){
        return Object.assign({}, state, {
          _shouldHandleWindowResize: true
        })
      }

      if(type === 'UI_HANDLE_WINDOW_RESIZE_START'){
        return Object.assign({}, state, {
          _shouldHandleWindowResize: false
        })
      }

      if(type === 'UI_HANDLE_WINDOW_RESIZE_FINISH'){
        const northConfig = {
          height: payload.hNorth
        }
        const southConfig = {
          height: payload.hSouth,
          children: state.southConfig.children,
          options: state.southConfig.options
        }
        return Object.assign({}, state, {
          northConfig: northConfig,
          southConfig: southConfig,
          _shouldResetMap: true
        })
      }

      if(type === 'UI_RESIZED_NORTH_SOUTH'){
        const northConfig = {
          height: payload.hNorth
        }
        const southConfig = {
          height: payload.hSouth,
          children: state.southConfig.children,
          options: state.southConfig.options
        }
        return Object.assign({}, state, {
          northConfig: northConfig,
          southConfig: southConfig
        })
      }

      if(type === 'UI_OPENED_SOUTH_PANEL'){
        const northConfig = {
          height: window.innerHeight / 2
        }
        const southConfig = {
          height: window.innerHeight / 2,
          children: payload.children
        }
        return Object.assign({}, state, {
          northConfig: northConfig,
          southConfig: southConfig
        })
      }

      if(type === 'UI_CLOSED_SOUTH_PANEL'){
        const northConfig = {
          height: window.innerHeight
        }
        const southConfig = {
          height: 0,
          children: []
        }
        return Object.assign({}, state, {
          northConfig: northConfig,
          southConfig: southConfig
        })
      }

      if(type === 'UI_CLOSED_SOUTH_TAB'){
        const southConfig = {
          children: payload.children
        }
        return Object.assign({}, state, {
          southConfig: southConfig
        })
      }

      if(type === 'UI_OPENED_MODAL_WINDOW'){
        const modalConfig = {
          children: payload.children,
          options: payload.options,
          openedBy: payload.openedBy
        }
        return Object.assign({}, state, {
          modalConfig: modalConfig
        })
      }

      if(type === 'UI_CLOSED_MODAL_WINDOW'){
        const modalConfig = {
          children: [],
          options: null,
          openedBy: null
        }
        return Object.assign({}, state, {
          modalConfig: modalConfig
        })
      }

      if(type === 'UI_OPENED_PRIMARY_PANEL'){
        const primaryPanelConfig = {
          openedBy: payload.openedBy,
          width: state.primaryPanelConfig.width,
          children: payload.children,
          options: payload.options
        }
        return Object.assign({}, state, {
          primaryPanelConfig: primaryPanelConfig
        })
      }

      if(type === 'UI_CLOSED_PRIMARY_PANEL'){
        const primaryPanelConfig = {
          openedBy: null,
          width: state.primaryPanelConfig.width,
          left: state.primaryPanelConfig.left,
          children: [],
          options: null
        }
        return Object.assign({}, state, {
          primaryPanelConfig: primaryPanelConfig
        })
      }

      if(type === 'UI_RESIZED_PRIMARY_PANEL'){
        const primaryPanelConfig = {
          open: state.primaryPanelConfig.open,
          width: payload.width,
          left: state.primaryPanelConfig.left,
          children: state.primaryPanelConfig.children,
          options: state.primaryPanelConfig.options,
          openedBy: state.primaryPanelConfig.openedBy
        }
        const secondaryPanelConfig = {
          open: state.secondaryPanelConfig.open,
          width: state.secondaryPanelConfig.width,
          left: payload.width,
          children: state.secondaryPanelConfig.children,
          options: state.secondaryPanelConfig.options,
          openedBy: state.secondaryPanelConfig.openedBy
        }
        return Object.assign({}, state, {
          primaryPanelConfig: primaryPanelConfig,
          secondaryPanelConfig: secondaryPanelConfig
        })
      }

      if(type === 'UI_ACTIVATE_BASIC_TOOL'){
        const basicToolbarConfig = {
          activeTool: payload
        }
        return Object.assign({}, state, {
          basicToolbarConfig: basicToolbarConfig
        })
      }

      if(type === 'UI_DEACTIVATE_BASIC_TOOL'){
        const basicToolbarConfig = {
          activeTool: null
        }
        return Object.assign({}, state, {
          basicToolbarConfig: basicToolbarConfig
        })
      }

      if(type === 'UI_THEME_CHANGED'){
        return Object.assign({}, state, payload)
      }
      if(type === 'UI_THEME_RETRIEVED'){
        return Object.assign({}, state, payload)
      }
      if(type === 'UI_SET_COOKIE'){
        return Object.assign({}, state, payload)
      }

      return state;
    }
  },

  // ACTION CREATORS
  doUIGetCookie: () => ({ dispatch, store }) => {
    dispatch({type: 'UI_THEME_RETRIEVED', payload: {shouldGetCookie: false}});
    const theme = Cookies.get('theme');
    let savedTheme = 'bg-nid';
    let shouldSetCookie = true
    if(theme) {
      savedTheme = theme;
      shouldSetCookie = false
    }
    dispatch({type:'UI_THEME_CHANGED', payload: {theme:savedTheme, shouldSetCookie:shouldSetCookie}});
    
  },
  doUISetCookie: () => ({ dispatch, store }) => {
    dispatch({type: 'UI_SET_COOKIE', payload: {shouldSetCookie: false}});
    const theme = store.selectTheme();
    Cookies.set('theme', theme)
    dispatch({type:'UI_THEME_CHANGED', payload: {theme}});
  },

  doMapUpdateSize: () => ({ dispatch, store }) => {
    const map = store.selectMap();
    window.setTimeout(() => { map.updateSize(); }, 100);
  },

  doOpenSouthRegion: ({ component, options, openedBy, displayName }) => ({ dispatch, store }) => {
    const existingChildren = store.selectSouthRegionChildren();
    const uid = v4();
    dispatch({type:'UI_OPENED_SOUTH_PANEL', payload:{ 
      children: existingChildren.concat([{ component, options, openedBy, displayName, uid }])
    }});
    store.doMapUpdateSize();
  },

  doCloseSouthTab: (child) => ({ dispatch, store }) => {
    const children = store.selectSouthRegionChildren().slice();
    const idx = children.indexOf(child);
    children.splice(idx, 1);
    dispatch({type:'UI_CLOSED_SOUTH_TAB', payload: { children: children }});
    if(children.length === 0) return store.doCloseSouthRegion();
  },

  doCloseSouthRegion: () => ({ dispatch, store }) => {
    dispatch({type:'UI_CLOSED_SOUTH_PANEL'});
    store.doMapUpdateSize();
  },

  doOpenModalWindow: ({ children, options, openedBy }) => ({ dispatch }) => {
    dispatch({type:'UI_OPENED_MODAL_WINDOW', payload: {children, options, openedBy }});
  },

  doCloseModalWindow: () => ({ dispatch }) => {
    dispatch({type:'UI_CLOSED_MODAL_WINDOW'});
  },

  doOpenPrimaryPanel: ({ children, options, openedBy }) => ({ dispatch }) => {
    dispatch({type:'UI_OPENED_PRIMARY_PANEL', payload:{ children, options, openedBy }});
  },

  doClosePrimaryPanel: () => ({ dispatch }) => {
    dispatch({type:'UI_CLOSED_PRIMARY_PANEL'});
  },

  doOpenSecondaryPanel: ({ children, options, openedBy }) => ({ dispatch }) => {
    dispatch({type:'UI_OPENED_SECONDARY_PANEL', payload:{ children, options, openedBy }});
  },

  doCloseSecondaryPanel: () => ({ dispatch }) => {
    dispatch({type:'UI_CLOSED_SECONDARY_PANEL'});
  },

  doSetTheme: (newTheme) => ({ dispatch }) => {
    dispatch({type:'UI_THEME_CHANGED', payload: {theme:newTheme, shouldSetCookie: true}});
  },

  doResizeSouthRegion: ({ hNorth, hSouth }) => ({ dispatch, store }) => {
    dispatch({type:'UI_RESIZED_NORTH_SOUTH', payload:{ hNorth, hSouth }});
    store.doMapUpdateSize()
  },

  doResizePrimaryPanel: ({ width }) => ({ dispatch }) => {
    dispatch({type:'UI_RESIZED_PRIMARY_PANEL', payload:{ width }});
  },

  doActivateBasicTool: ({ activeTool }) => ({ dispatch }) => {
    dispatch({type:'UI_ACTIVATE_BASIC_TOOL', payload: activeTool });
  },

  doDeactivateBasicTool: () => ({ dispatch }) => {
    dispatch({type:'UI_DEACTIVATE_BASIC_TOOL'});
  },

  doHandleWindowResize: () => ({ dispatch, store }) => {
    dispatch({ type: 'UI_HANDLE_WINDOW_RESIZE_START' })
    const n = store.selectNorthHeight();
    const s = store.selectSouthHeight();
    const h = store.selectViewportHeight();
    const newN = Math.round((n / (n + s)) * h);
    const newS = h - newN;
    dispatch({
      type: 'UI_HANDLE_WINDOW_RESIZE_FINISH',
      payload: {
        hNorth: newN,
        hSouth: newS
      }
    })
  },

  doResetMap: () => ({ dispatch, store }) => {
    dispatch({ type: 'UI_RESET_MAP' })
    const map = store.selectMap();
    map.updateSize();
  },

  // SELECTORS
  selectNorthHeight: (state) => {
    return state.ui.northConfig.height;
  },

  selectSouthHeight: (state) => {
    return state.ui.southConfig.height;
  },

  selectSouthRegionChildren: (state) => {
    return state.ui.southConfig.children;
  },

  selectModalChildren: (state) => {
    return state.ui.modalConfig.children;
  },

  selectModalOptions: (state) => {
    return state.ui.modalConfig.options;
  },

  selectPrimaryPanelOpenedBy: (state) => {
    return state.ui.primaryPanelConfig.openedBy;
  },

  selectPrimaryPanelChildren: (state) => {
    return state.ui.primaryPanelConfig.children;
  },

  selectPrimaryPanelOptions: (state) => {
    return state.ui.primaryPanelConfig.options;
  },

  selectPrimaryPanelWidth: (state) => {
    return state.ui.primaryPanelConfig.width;
  },

  selectActiveBasicTool: (state) => {
    return state.ui.basicToolbarConfig.activeTool;
  },

  selectTheme: (state) => {
    return state.ui.theme;
  },

  reactShouldHandleWindowResize: (state) => {
    if(state.ui._shouldHandleWindowResize) return { actionCreator: 'doHandleWindowResize' };
  },

  reactShouldResetMap: (state) => {
    if(state.ui._shouldResetMap) return { actionCreator: 'doResetMap' };
  },
  reactUIShouldGetCookie: (state) => {
    if(state.ui.shouldGetCookie) return { actionCreator: 'doUIGetCookie' };
  },
  reactUIShouldSetCookie: (state) => {
    if(state.ui.shouldSetCookie) return { actionCreator: 'doUISetCookie' };
  },
  // init: (store) => {
  //   window.addEventListener('resize', debounce(store.doHandleResize, 300));
  // }
}